import React, { useState } from "react";
import Auth from "./Auth";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { NavLink } from "react-router-dom";
import axiosInstance from "@/utils/axiosInstance";

const ForgotPass = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("")

  const submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setLoading(true);
    try {
        const {data} = await axiosInstance.post('/auth/user/forget-password', {email})
        toast(data.message || `We sent a password to ${email}`)
    } catch (err) {
        toast(err.response.data.message)
    } finally {
        setLoading(false)
    }
  };

  return (
    <Auth
      title="Reset your password"
      description="Enter your email to recieve a new password"
      buttonTitle="Reset password"
      loading={loading}
      submitForm={(e: React.FormEvent<HTMLFormElement>) => submitForm(e)}
    >
      <div className="grid gap-2">
        <div className="flex items-center">
          <Label htmlFor="password">Email</Label>
          <NavLink to="/login" className="ml-auto text-sm underline-offset-2 hover:underline">Sign in</NavLink>
        </div>
        <div className="relative">
          <Input
            id="email"
            name="email"
            type="email"
            value={email}
            onChange={(e: React.FormEvent<HTMLInputElement>) => setEmail(e.currentTarget.value)}
            placeholder="type your email"
            required
            className="pr-10"
          />
        </div>
      </div>
    </Auth>
  );
};

export default ForgotPass
